import { LoadingOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUpgradeFlag } from "services/lookupSelector";
import { Button } from "shared/components/Button";
import env from "shared/constants/env";
import routes, { appRoute } from "shared/constants/routes";
import { useTranslation } from "../../../contexts/TranslationContext";

// Helper function to get the correct endpoint based on application source
const getEndpointForApp = (appId) => {
  const upgradedUser = getUpgradeFlag();

  // For v2 users, always use v2 endpoint
  // if (upgradedUser) {
  //   return env.API_ENDPOINT_V2;
  // }

  // For v1 users, check application source
  try {
    const appSourceMap = JSON.parse(localStorage.getItem('userAppsSourceMap') || '{}');
    if (appSourceMap[appId]) {
      return appSourceMap[appId] === 'v1' ? env.API_ENDPOINT : env.API_ENDPOINT_V2;
    }
  } catch (error) {
    console.error("Error checking cached app source:", error);
  }

  // Fallback to v1 for v1 users
  return env.API_ENDPOINT;
};

export default function AcceptModal({ appId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { translate } = useTranslation();

  const navigate = useNavigate();

  const handleConfirm = async () => {
    try {
      setLoading(true);

      // Determine endpoint based on application source
      const endpoint = `${getEndpointForApp(appId)}app/customer-contract-decision`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerStatus: 'ACCEPTED',
          appId: `${appId}`,
        }),
      });

      const data = await response.json();

      if (data?.success) {
        toast.success('Contract Accepted');
      } else {
        toast.error(data?.message || "Unable to accept Contract");
      }
    } catch (ex) {
      toast.error("Unable to accept Contract, please try again");
    } finally {
      setIsOpen(false);
      setLoading(false);
      navigate(appRoute(routes.HOME));
    }
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)} color="primary" className="rounded-xl h-12 w-32">
        {translate("OFFER_TABLE.ACCEPT")}
      </Button>
      <Modal
        open={isOpen}
        title={translate("OFFER_TABLE.CONFIRM")}
        onCancel={() => setIsOpen(false)}
        footer={
          <Button disabled={loading} onClick={handleConfirm} color="primary" className="rounded-xl min-w-32">
            {loading ? <LoadingOutlined /> : translate("OFFER_TABLE.CONFIRM")}
          </Button>
        }
      >
        {translate("CONTRACT.CONTRACT_ACCEPTANCE")}
      </Modal>
    </>
  );
}
